import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default function downloadExcel (headers, data) {
  const book = XLSX.utils.book_new()
  book.SheetNames.push('Report')
  const sheet = [headers, ...data]
  const ws = XLSX.utils.aoa_to_sheet(sheet)
  book.Sheets.Report = ws
  const bookOut = XLSX.write(book, { bookType: 'xlsx', type: 'binary' })

  function s2ab (s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  }

  saveAs(new Blob([s2ab(bookOut)], { type: 'application/octet-stream' }), 'scanvaegt_report.xlsx')
}
